<template>
    <div id="ElectronicCard" class="app-inner">
         <div class="p-tit-c">
            <div class="businessList-filter">
                   <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">使用者ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入使用者ID" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">名片姓名：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入名片姓名" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                    <div class="fl-rt flex align-cen">
                    <div class="label">手机号：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入手机号" v-model="search2" clearable> </el-input>
                    </div>
                    </div>
                </div>
                       <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="dataSuccess">
          搜索
        </div>
        <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
          导出
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
            </div>
         </div>
             <div class="businessList-container">
        <div class="businessList-container-table">
           <el-table
                ref="multipleTable"
                :data="list"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                 :row-key="getRowKeyOfTarget"
                 @selection-change="handleSelectionChange"
                >
                 <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
                <el-table-column prop="id" label="使用者id" align="center">
                 </el-table-column>
                 <el-table-column prop="phone" label="手机号" align="center">
                 </el-table-column>
                   <el-table-column prop="name" label="名片姓名" align="center">
                 </el-table-column>
                  <el-table-column prop="shareNum" label="发名片（次）" align="center">
                 </el-table-column>
                  <el-table-column prop="visitNum" label="访问总量（次）" align="center">
                 </el-table-column>
                  <el-table-column prop="todayVisitNum" label="今日访问量（次）" align="center">
                 </el-table-column>
                 <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            >
             <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
                  </el-table>
                   <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
             </div>
    </div>
</template>
<script>
import { getVcard} from "@/api/index/index"; // 电子名片查询接口
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import exportExcel from '../../utils/exportExcel.js' //导出数据公共方法
export default {
    name:'ElectronicCard',
    components:{
      paginaTion,
    },
    data() {
        return {
            search:'',
            search1:'',
            search2:'',
            multipleSelection:[],
            list:[],
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
        }
    },
    activated(){
        this.getList()
    },
    created() {
        this.getList()
    },
    methods: {
        // 打开电子名片详情
        openDetail(data){
             this.$router.push({name:'cardDetail',query:{id:data.id}})
        },
        // 查询电子名片分页列表
        getList(){
        let params = {
            id:this.search,
            name:this.search1,
            phone:this.search2,
            current: this.currentPage,
            size:this.PageSize,
        }
         getVcard(params)
         .then(res =>{
             this.list = res.data.records
             this.totalCount = res.data.total;
         })
        },
                       // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
             getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
        // 导出
           // 导出
      exportExcel(val){
        if(val.length !=0){
          let keyLisst = [] 
          for(let item in val){
             keyLisst.push( {
              '使用者ID':val[item].id, 
              '手机号':val[item].phone, 
              '名片姓名':val[item].name,
              '发名片（次）':val[item].shareNum,
              '访问总量（次）':val[item].visitNum, 
              '今日访问量（次）':val[item].todayVisitNum,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
        }
        else{
          this.$util.Notifi('请选择导出数据','error','fa-exclamation-circle')
        }
      },
        // 重置
        reset(){
            this.currentPage = 1
            this.search = ''
            this.search1 = ''
            this.search2 = ''
            this.getList()
        },
        // 搜索
        dataSuccess(){
            this.currentPage = 1
            this.getList()
        }
    },
}
</script>
<style lang="scss" scoped>

</style>